import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';

function groupBy(collection, key) {
  return collection.reduce(function (out, obj) {
    var _extends2;

    return _extends({}, out, (_extends2 = {}, _extends2[obj[key]] = (out[obj[key]] || []).concat(obj), _extends2));
  }, {});
}
function arraysEqual(a, b, order) {
  if (order === void 0) {
    order = true;
  }

  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;
  var cA = order ? a : a.sort();
  var cB = order ? b : b.sort();

  for (var i = 0; i < cA.length; i += 1) {
    if (cA[i] !== cB[i]) return false;
  }

  return true;
}

export { arraysEqual, groupBy };
//# sourceMappingURL=array.esm.js.map
